import { useState } from "react";
import Button from "../../../../shared/components/Button";
import Toast from "../../../../shared/components/Toast";
import { getLeagueTexts } from "../leagueTexts";
import EmptyState from "../../../../shared/components/EmptyState";

export default function LeagueLoadError({ error, retry }: { error: string; retry: () => void }) {
  const t = getLeagueTexts();
  const [dismissed, setDismissed] = useState(false);
  return <>
    <EmptyState
      title={t.loadError}
      icon={
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v6M12 16h.01" strokeLinecap="round" />
        </svg>
      }
      action={<Button onClick={retry} variant="ghost">{t.retry}</Button>}
    />
    {!dismissed && <Toast message={error} variant="error" onClose={() => setDismissed(true)} />}
  </>;
}
